import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import UserLayoutClassic from './UserLayoutClassic';
import UserLayoutModern from './UserLayoutModern';

const UserLayout = () => {
  const { user } = useAuth();

  // PROMPT-114: Dynamic layout selection based on user preference
  // Priority: user.ui_mode -> fallback to 'classic'
  const uiMode = user?.ui_mode || 'classic';

  // Select layout component based on ui_mode
  const LayoutComponent = uiMode === 'modern' ? UserLayoutModern : UserLayoutClassic;

  return <LayoutComponent />;
};

export default UserLayout;
